const middleware = {}

middleware['setHeaders'] = require('../middleware/setHeaders.js')
middleware['setHeaders'] = middleware['setHeaders'].default || middleware['setHeaders']

export default middleware
